import { HttpApiSecurity, HttpApplication } from '../index';

import { authTokenInterceptor } from './authTokenInterceptor';
import { handleError } from './handleError';

const ConfigureAxiosInterceptors = () => {
  HttpApplication.service.interceptors.request.use(
    (conf: any) => {
      return authTokenInterceptor(conf);
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );

  HttpApplication.service.interceptors.response.use((config) => {
    return config;
  }, handleError);

  HttpApiSecurity.service.interceptors.request.use(
    (conf: any) => {
      return authTokenInterceptor(conf);
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );

  HttpApiSecurity.service.interceptors.response.use((config) => {
    return config;
  }, handleError);
};

export default {
  ConfigureAxiosInterceptors
};
